module.exports = __webpack_public_path__ + "static/media/youtube-logo.a3e97175.png";